import React from "react";
import { ReactComponent as Design01 } from "../../../icons/design01.svg";
import { ReactComponent as Design02 } from "../../../icons/design02.svg";
import "./index.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import useRedirecting from "./hooks/useRedirecting";

const Redirecting = (props) => {
  useRedirecting(props);

  return (
    <div className="redirection">
      <div className="bg-design-wrapper">
        <div className="design01">
          <Design01 />
        </div>
        <div className="design02">
          <Design02 />
        </div>
        <div className="out-card-wrapper">
          <div className="loader"></div>
          <div className="card-wrapper">
            <h5 className="title">
              {`Redirecting  `}
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </h5>
            <p className="message">
              Please wait a while. You are being redirected
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, null)(withRouter(Redirecting));
